// actions/noteActions.js
import courseService from "../services/course.service";

export const SET_NOTE_FINALE = "SET_NOTE_FINALE";

export const setNoteFinale = (note) => ({
  type: SET_NOTE_FINALE,
  payload: note,
});

export const recalculateNote = (courseId, userId) => async (dispatch) => {
  console.log("🔄 [recalculateNote] Début - courseId:", courseId, "userId:", userId);

  try {
    const notes = await courseService.CalculeNoteFinale(courseId, userId);
    console.log("📥 [recalculateNote] Réponse API:", notes);

    if (!notes || notes.length === 0) {
      console.warn("⚠️ [recalculateNote] Pas de données retournées par l'API");
      dispatch(setNoteFinale(null));
      return;
    }

    if (notes[0].noteEvaluation === null || notes[0].noteEvaluation === 0) {
      console.warn("⚠️ [recalculateNote] Note évaluation vide ou nulle");
      dispatch(setNoteFinale(null));
      return;
    }

    console.log("✅ [recalculateNote] Données valides envoyées au store:", notes[0]);
    dispatch(setNoteFinale(notes[0]));
  } catch (error) {
    console.error("❌ [recalculateNote] Erreur API:", error);
  }
};

